export interface PaymentConfigServiceV1 {
  getConfig: () => PaymentConfigV1 | undefined;

  setConfig: (config: PaymentConfigV1) => void;

  subscribe: (
    onConfigChange: ConfigChangeListenerV1,
    options?: {readonly signal?: AbortSignal; matchers: string[]},
  ) => () => void;

  registerCalculatorLoader: (
    loadCalculator: () => void,
    options?: {readonly signal?: AbortSignal},
  ) => () => void;

  registerCalculator: (
    onOpenCalculator: OpenCalculatorListenerV1,
    options?: {readonly signal?: AbortSignal},
  ) => () => void;

  openCalculator: (options: OpenCalculatorOptionsV1) => void;
}

export enum PaymentConfigMode {
  CASHBUY = `cash-buy`,
  LEASING = `leasing`,
  FINANCE = `finance`,
}

export type PaymentConfigV1 =
  | {readonly mode: PaymentConfigMode.CASHBUY}
  | {
      readonly mode: PaymentConfigMode.LEASING;
      readonly leasingParams: LeasingParamsV1;
      readonly params: LeasingParamsV1;
    }
  | {
      readonly mode: PaymentConfigMode.FINANCE;
      readonly params: FinanceParamsV1;
    };

export interface LeasingParamsV1 {
  readonly advancePayment: number;
  readonly duration: number;
  readonly mileage: number;
}

export interface FinanceParamsV1 {
  readonly advanceMonth: number;
  readonly duration: number;
  readonly mileage: number;
}

export type ConfigChangeListenerV1 = (
  options: ConfigChangeListenerOptionsV1,
) => void | Promise<void>;

export interface ConfigChangeListenerOptionsV1 {
  readonly consumerId: string;
  readonly purchaseItem: PurchaseItemV1;
}

export type PurchaseItemV1 =
  | {
      readonly type: 'pn18';
      readonly pn18: string;
    }
  | {
      readonly type: 'cart-item';
      readonly cartId: string;
      readonly cartEntryNumber: number;
    }
  | {
      readonly type: 'none';
    };

export type OpenCalculatorListenerV1 = (
  options: OpenCalculatorListenerOptionsV1,
  closeCalculator: CloseCalculatorCallbackV1,
  onChange: CloseCalculatorCallbackV1,
) => void;

export interface OpenCalculatorListenerOptionsV1 {
  readonly purchaseItem: PurchaseItemV1;
  readonly calculatorConfig: CalculatorConfigV1 | undefined;
}

export interface CalculatorConfigV1 {
  readonly mode: PaymentConfigMode;
  readonly leasingParams?: LeasingParamsV1;
  readonly params?: LeasingParamsV1 | FinanceParamsV1;
}

export type CloseCalculatorCallbackV1 = (
  config: PaymentConfigV1,
  event: string,
) => void | Promise<void>;

export interface OpenCalculatorOptionsV1 {
  readonly purchaseItem: PurchaseItemV1;
  readonly initialConfig: PaymentConfigV1 | undefined;
}
